import { format as formatFns } from 'date-fns'
import moment from 'moment'
import { toast } from 'react-toastify'
import dayjs, { Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export const dateFormatted = (strDate: string): any => {
  const date = formatFns(moment(strDate).toDate(), 'dd/MM/yyyy')
  const hours = formatFns(moment(strDate).toDate(), 'HH:mm')
  return { date, hours }
}

export function getDateHours(dateHours: any) {
  if (!dateHours) return
  const formatting: any = new Date(dateHours)
  const { date, hours } = dateFormatted(formatting)
  return `${date} às ${hours}`
}

export function base64ToBlob(base64: string, contentType: string) {
  const byteCharacters = atob(base64)
  const byteNumbers = new Array(byteCharacters.length)

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }

  const byteArray = new Uint8Array(byteNumbers)

  return new Blob([byteArray], { type: contentType })
}

export function downloadFileBlob(fileName: string, blob: Blob): void {
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = fileName

  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
}

export function downloadFile(
  fileName: string,
  data: any,
  fileFormat: string
): void {
  const linkSource = 'data:' + fileFormat + ';base64,' + data
  const downloadLink = document.createElement('a')
  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export const emailValidation =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const formatCurrency = (value: number, cents = true) => {
  if (!value) return

  const currency = new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL'
  }).format(value)

  if (!cents) return currency.split(',')[0]

  return currency
}

export const formatNumber = (value: number) => {
  if (isNaN(value)) return

  return new Intl.NumberFormat().format(value)
}

export const formatDate = (date: string): string => {
  if (!date) return ''
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }
  return Intl.DateTimeFormat('pt-BR', options).format(new Date(date))
}

export const validateCnpj = function (cnpj: string) {
  cnpj = cnpj.replace(/[^\d]+/g, '')

  if (cnpj == '') {
    return false
  }

  if (cnpj.length != 14) {
    return false
  }

  // Eliminates known invalid CNPJs
  if (
    cnpj == '00000000000000' ||
    cnpj == '11111111111111' ||
    cnpj == '22222222222222' ||
    cnpj == '33333333333333' ||
    cnpj == '44444444444444' ||
    cnpj == '55555555555555' ||
    cnpj == '66666666666666' ||
    cnpj == '77777777777777' ||
    cnpj == '88888888888888' ||
    cnpj == '99999999999999'
  ) {
    return false
  }

  let size = cnpj.length - 2
  let numbers = cnpj.substring(0, size)
  let digits = cnpj.substring(size)
  let sum = 0
  let pos = size - 7

  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--

    if (pos < 2) {
      pos = 9
    }
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11)

  if (result != parseInt(digits.charAt(0))) {
    return false
  }

  size = size + 1
  numbers = cnpj.substring(0, size)
  sum = 0
  pos = size - 7

  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i)) * pos--

    if (pos < 2) {
      pos = 9
    }
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11)

  if (result != parseInt(digits.charAt(1))) {
    return false
  }

  return true
}

export const validateCpf = function (cpf: string) {
  cpf = cpf.replace(/[\s.-]*/gim, '')

  if (
    !cpf ||
    cpf.length != 11 ||
    cpf == '00000000000' ||
    cpf == '11111111111' ||
    cpf == '22222222222' ||
    cpf == '33333333333' ||
    cpf == '44444444444' ||
    cpf == '55555555555' ||
    cpf == '66666666666' ||
    cpf == '77777777777' ||
    cpf == '88888888888' ||
    cpf == '99999999999'
  ) {
    return false
  }

  let sum = 0
  let rest

  for (let i = 1; i <= 9; i++) {
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
  }

  rest = (sum * 10) % 11

  if (rest == 10 || rest == 11) {
    rest = 0
  }

  if (rest != parseInt(cpf.substring(9, 10))) {
    return false
  }

  sum = 0

  for (var i = 1; i <= 10; i++) {
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
  }

  rest = (sum * 10) % 11

  if (rest == 10 || rest == 11) {
    rest = 0
  }

  if (rest != parseInt(cpf.substring(10, 11))) {
    return false
  }

  return true
}

export const validatePhone = function (phone: string) {
  const available_ddds = [
    11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35,
    37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64,
    65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88,
    89, 91, 92, 93, 94, 95, 96, 97, 98, 99
  ]

  if (!phone) {
    return false
  }

  const phoneLength = phone.length

  if (phoneLength < 14 || phoneLength > 15) {
    return false
  }

  const ddd = phone.substring(1, 3)
  const int_ddd = parseInt(ddd)

  if (available_ddds.indexOf(int_ddd) < 0) {
    return false
  }

  return true
}

export const unMask = (value: string) => {
  if (!value) return
  return value.replace(/[^a-zA-Z0-9]/g, '')
}

export const prepareFilters = (value: string) => {
  switch (value) {
    case 'Vistoria de venda':
      return 'VistoriaVenda'
    case 'Vistoria de rotina':
      return 'VistoriaRotina'
    case 'Vistoria de compra':
      return 'VistoriaCompra'
    case 'Vistoria de entrega':
      return 'VistoriaEntrega'
    case 'Em cadastramento':
      return 'EmCadastramento'
    case 'Em atraso':
      return 'EmAtraso'
    case 'Dentro do prazo':
      return 'DentroDoPrazo'
    case 'Operacional A':
      return 'OperacionalA'
    case 'Operacional B':
      return 'OperacionalB'
    case 'Operacional C':
      return 'OperacionalC'
    case 'Operacional D':
      return 'OperacionalD'
    case 'Não operacional':
    case 'Não Operacional':
      return 'NaoOperacional'
    case 'Desmobilização':
      return 'Desmobilizacao'
    case 'Aguardando aprovação':
      return 'AguardandoAprovacao'
    case 'Em andamento':
      return 'EmAndamento'
    case 'Concluído':
      return 'Concluida'
    case 'Não realizado':
      return 'NaoRealizado'
    case 'Indicado divergência':
      return 'Divergencia'
    case 'Em processamento':
      return 'Processamento'
    case 'Aguardando confirmação do e-mail':
      return 'AguardandoConfirmacaoEmail'
    case 'Aguardando análise':
      return 'AguardandoAnalise'
    case 'Não se Aplica':
    case 'Não se aplica':
      return 'NaoAplica'
    default:
      return value
  }
}

export const capitalized = (str: string) =>
  str[0].toUpperCase() + str.substring(1)

export function extractItem(data: any[], keys: string[]) {
  return data.map((item, index) => {
    const extractedData = keys.reduce((acc: any, key) => {
      if (item.hasOwnProperty(key)) {
        acc[key] = item[key]
      }

      return acc
    }, {})

    return { ...extractedData, value: String(index) }
  })
}

export const fileToBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
  })

export const blobToBase64 = (blob: any) =>
  new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })

export const today = moment(new Date()).toDate()

const isBase64 = (str: any) => {
  const base64regex =
    /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/
  if (!base64regex.test(str)) {
    return false
  }
  try {
    const decoded = atob(str)
    const isPrintable = /^[\x20-\x7E]*$/.test(decoded)
    return isPrintable
  } catch (err) {
    return false
  }
}

export function unicodeDecodeB64(str: any): any {
  if (!str) return null

  const arrParams = str.split(/&/)
  const filters: any = {}
  arrParams.forEach((el: any) => {
    const [prop, value] = el.split('=')
    const val = value
      .replaceAll('%3D', '=')
      .replaceAll('%2C', ',')
      .replaceAll('+', ' ')
    let decodedValue = val

    try {
      decodedValue =
        'true false'.indexOf(val) === -1 && prop !== 'orderColumn'
          ? isBase64(val)
            ? decodeURIComponent(atob(val))
            : val
          : val
    } catch (error) {
      decodedValue = val
    }
    filters[prop] =
      prop !== 'pageSize' && prop !== 'pageNumber' ? decodedValue : val
  })
  return filters
}

export function serializeFormQuery(formData: any): string {
  const filters: any[] = []
  Object.keys(formData).forEach((key) => {
    const value = formData[key]
    if (value !== undefined && value !== null) {
      let data

      if (Array.isArray(value))
        data = btoa(
          encodeURIComponent(JSON.stringify(Object.values({ ...value })))
        )
      else if (typeof value === 'object')
        data = btoa(encodeURIComponent(JSON.stringify({ ...value })))
      else data = encodeURIComponent(value)

      filters.push(`${key}=${data}`)
    }
  })

  return filters.join('&')
}

export const formatDayjsToISO = (dateObj: any) => {
  if (!dateObj?.$d) {
    return null
  }
  return dateObj?.$d
}

export const convertToUtcDayjs = (
  dateObj?: { $d?: Date } | null
): Dayjs | null => {
  if (!dateObj?.$d) return null
  return dayjs.utc(dateObj.$d)
}

export const addLeadingSlash = (path: string) => {
  return path.startsWith('/') ? path : `/${path}`
}

export const normalizeClassName = (text: any) => {
  if (typeof text !== 'string') return ''
  return text
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
}

export function handleError(
  e: unknown,
  fallbackMessage = 'Ocorreu um erro. Tente novamente mais tarde.'
) {
  if (e instanceof Error) {
    toast.error(e.message)
  } else {
    toast.error(fallbackMessage)
  }
}

export function getEnumKeyByValue<T extends Record<string, string | number>>(
  enumObj: T,
  value: T[keyof T]
): keyof T | undefined {
  return (Object.keys(enumObj) as Array<keyof T>).find(
    (key) => enumObj[key] === value
  )
}

export function generateFilename(type: 'inspection', extension = 'jpg') {
  const filename = {
    inspection: `vistoria_${crypto.randomUUID()}.${extension}`
  }
  return filename[type]
}

export function getFileExtension(file: File): string {
  return file?.name?.split('.')?.pop() || ''
}

export function extractInspectionPhotoPath(url: string): string | null {
  const match = url.match(/\/plataforma-ativos-avalia-gab-[^\/]+\/([^?]+)/)
  return match ? match[1] : null
}

export function extractPhotoFileName(url: string): string | null {
  const match = url.match(/\/([^\/?]+\.[a-zA-Z0-9]+)(?:\?|$)/)
  return match ? match[1] : null
}

export const requestLocation = async () => {
  if (!navigator.geolocation) {
    console.error('Geolocalização não é suportada no seu navegador.')
    return null
  }
  return new Promise<{ latitude: number; longitude: number } | null>(
    (resolve) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          })
        },
        (error) => {
          console.error('Erro ao acessar localização:', error?.message)
          resolve(null)
        }
      )
    }
  )
}
